/**
 * Shared sx fragments that keep dashboard panels from overflowing horizontally.
 * Containers set `overflowWrap: 'anywhere'` (inherited); these cover the two cases
 * that opt out of normal wrapping.
 */

/** MUI Chip labels are `nowrap`; let a long label wrap inside the available width. */
export const CHIP_WRAP_SX = {
  maxWidth: '100%',
  height: 'auto',
  '& .MuiChip-label': { whiteSpace: 'normal', overflowWrap: 'anywhere', py: 0.25 },
};

/**
 * Code / SQL text: wrap at whitespace, but scroll (inside its own overflowX:auto box)
 * instead of breaking identifiers when a single token is wider than the box.
 */
export const CODE_PRE_SX = {
  fontFamily: 'monospace', whiteSpace: 'pre-wrap', overflowWrap: 'normal', wordBreak: 'normal', m: 0,
};

/** The scrolling box around CODE_PRE_SX. */
export const CODE_BOX_SX = {
  backgroundColor: '#f5f5f5', borderRadius: 1, p: 1, overflowX: 'auto', maxWidth: '100%', minWidth: 0,
};
